import { createSlice } from "@reduxjs/toolkit";

import {
  getServiceTypeThunk,
  createServiceTypeThunk,
  updateServiceTypeThunk,
  deleteServiceTypeThunk,
} from "state/action/service_type";

// Initial state
const initialState = {
  // Get ServiceType inisial state
  getServiceType: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Create ServiceType inisial state
  createServiceType: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  createServiceTypeInputBody: {
    code: "",
    service_type_name: "",
    services: [""],
    description: "",
  },
  // Update ServiceType inisial state
  updateServiceType: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Delete ServiceType inisial state
  deleteServiceType: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // ServiceType object value
  serviceType_object_value: "",
};

export const serviceTypeSlice = createSlice({
  name: "serviceType",
  initialState,
  reducers: {
    setGetServiceTypeObjectValue: (state, action) => {
      return {
        ...state,
        serviceType_object_value: action.payload,
      };
    },
    // note: clear state
    setClearGetServiceTypeObjectValue: (state, _) => {
      return {
        ...state,
        serviceType_object_value: "",
      };
    },
    setClearGetServiceType: (state, _) => {
      return {
        ...state,
        getServiceType: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    // setClearCreatePKSInputBody: (state, _) => {
    //   return {
    //     ...state,
    //     createPKSInputBody: {
    //       pks_id: "",
    //       title: "",
    //       version: 1,
    //       status: "Draft",
    //       issue_date: new Date(),
    //       valid_until_date: null,
    //       start_date: null,
    //       client: "",
    //       sales_person: "",
    //       department: "",
    //       services: [
    //         {
    //           service_type: "",
    //           description: "",
    //           quantity: 1,
    //           unit: "unit",
    //           unit_price: "",
    //           total_price: "",
    //           details: "",
    //         },
    //       ],
    //       summary: {
    //         subtotal: 0,
    //         discounts: [],
    //         taxes: [
    //           {
    //             tax_name: "PPN",
    //             rate_percent: 11,
    //             amount: 0,
    //           },
    //         ],
    //         grand_total: 0,
    //         currency: "IDR",
    //       },
    //       terms: {
    //         payment_schedule: [
    //           {
    //             description: "Pembayaran Penuh",
    //             percentage: 100,
    //             amount: 0,
    //             due_date: null,
    //           },
    //         ],
    //         scope_of_work: "",
    //         general_conditions: "",
    //       },
    //       notes: "",
    //       attachments: [],
    //     },
    //   };
    // },
    setSelectedPKS: (state, action) => {
      return {
        ...state,
        selectedPKS: action.payload,
      };
    },
    setCreateServiceTypeInputBody: (state, action) => {
      return {
        ...state,
        createServiceTypeInputBody: action.payload,
      };
    },
    setClearCreateServiceTypeInputBody: (state, _) => {
      return {
        ...state,
        createServiceTypeInputBody: {
          code: "",
          service_type_name: "",
          services: [""],
          description: "",
        },
      };
    },
    setClearCreateServiceType: (state, _) => {
      return {
        ...state,
        createServiceType: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearUpdateServiceType: (state, _) => {
      return {
        ...state,
        updateServiceType: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearDeleteServiceType: (state, _) => {
      return {
        ...state,
        deleteServiceType: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearAllServiceTypeState: (state, _) => {
      return {
        ...state,
        // Get ServiceType inisial state
        getServiceType: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Create ServiceType inisial state
        createServiceType: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Update ServiceType inisial state
        updateServiceType: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Delete ServiceType inisial state
        deleteServiceType: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // ServiceType object value
        ServiceType_object_value: "",
      };
    },
  },
  extraReducers(builder) {
    builder
      // Get ServiceType reducer
      .addCase(getServiceTypeThunk.pending, (state, _) => {
        return {
          ...state,
          getServiceType: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getServiceTypeThunk.fulfilled, (state, action) => {
        return {
          ...state,
          getServiceType: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getServiceTypeThunk.rejected, (state, action) => {
        return {
          ...state,
          getServiceType: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // Create ServiceType reducer
      .addCase(createServiceTypeThunk.pending, (state, _) => {
        return {
          ...state,
          register: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createServiceTypeThunk.fulfilled, (state, action) => {
        return {
          ...state,
          register: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createServiceTypeThunk.rejected, (state, action) => {
        return {
          ...state,
          register: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // update ServiceType reducer
      .addCase(updateServiceTypeThunk.pending, (state, _) => {
        return {
          ...state,
          updateServiceType: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateServiceTypeThunk.fulfilled, (state, action) => {
        return {
          ...state,
          updateServiceType: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateServiceTypeThunk.rejected, (state, action) => {
        return {
          ...state,
          updateServiceType: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      });
  },
});

export const serviceTypeAction = {
  ...serviceTypeSlice.actions,
  getServiceTypeThunk,
  createServiceTypeThunk,
  updateServiceTypeThunk,
  deleteServiceTypeThunk,
};

export function selectServiceTypeObjectValue(state) {
  return state?.serviceType?.serviceType_object_value;
}

export function selectServiceType(state) {
  return state?.serviceType;
}

export default serviceTypeSlice.reducer;
